import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Device } from 'app/models/device.model';
import { Firmware } from 'app/models/firmware.model';
import { CompanyService } from 'app/services/company.service';
import { DeviceService } from 'app/services/device.service';
import { FirmwareService } from 'app/services/firmware.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';

@Component({
    selector: 'app-device-firmware-update',
    templateUrl: './device-firmware-update.component.html',
    styleUrls: ['./device-firmware-update.component.scss']
})
export class DeviceFirmwareUpdateComponent extends BaseFormComponent implements OnInit {

    private _firmware: Array<Firmware> = [];
    public get firmware(): Array<Firmware> {
        return this._firmware;
    }
    public set firmware(v: Array<Firmware>) {
        this._firmware = v;
    }


    private _devices: Array<Device> = [];
    public get devices(): Array<Device> {
        return this._devices;
    }
    public set devices(v: Array<Device>) {
        this._devices = v;
    }


    public selectedFirmware: Firmware;

    constructor(
        private _deviceService: DeviceService,
        private _dialog: MatDialog,
        private _toastService: ToasterService,
        private _firmwareService: FirmwareService,
        private _companyService: CompanyService,
        private _translateService: TranslateService
    ) {
        super();
    }


    ngOnInit() {
        this.getFirmwareList();
    }

    public async getFirmwareList() {
        try {
            this.firmware = await this._firmwareService.getFirmwareCompany(parseInt(localStorage.getItem("CompanyID")))
        } catch (error) {
            console.warn(error);
        }
    }

    public async save() {
        if (!this.selectedFirmware) {
            this._toastService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }

        this.devices.map(x=>{
            x.firmware = this.selectedFirmware['version'];
            x.firmwareUpdateCheck = true;
        })

        try {
            var result = await this._deviceService.updateRange(this.devices)
            this.updated.emit(result)
        } catch (error) {
            console.warn(error);
            debugger;
            this.updated.emit(error)
        }
    }
}
